export default function TitleGlassPill({ label, left })
{
    const leftPosition =
        left ?
            left :
            "calc(50% + 60px)";

    return (
        <div
            style={{
                position: "absolute",

                top: "5px",

                left: leftPosition,

                transform: "translateX(-50%)",

                minWidth: "500px",

                padding: "0px 40px",

                height: "48px",

                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                background:
                    "linear-gradient(135deg, rgba(255,255,255,0.55), rgba(255,255,255,0.25))",

                border:
                    "1px solid rgba(255,255,255,0.7)",

                borderRadius: "24px",

                backdropFilter: "blur(10px)",

                boxShadow:
                    "0 10px 30px rgba(0,0,0,0.15)",

                color: "#444",

                fontSize: "20px",

                fontWeight: "500",

                letterSpacing: "0.5px",

                zIndex: 500000
            }}
        >
            {label}
        </div>
    );
}